import React from "react";
import auth from "shared/Auth0";

const LoginButton = () => {
  const signInWithEmail = (e: React.MouseEvent) => {
    e.preventDefault();
    auth.logout();
    auth.signInWithEmail();
  };

  return (
    <button
      onClick={signInWithEmail}
      className="
        w-full flex items-center justify-center gap-3
        bg-[#5FA5F8] hover:bg-[#4a94e8] active:bg-[#3a83d7]
        text-white text-sm font-semibold
        px-6 py-3.5 rounded-xl
        shadow-md shadow-[#5FA5F8]/30
        transition-all duration-200
        focus:outline-none focus:ring-2 focus:ring-[#5FA5F8] focus:ring-offset-2
      "
    >
      <svg
        className="w-5 h-5 shrink-0"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" />
        <polyline points="10 17 15 12 10 7" />
        <line x1="15" y1="12" x2="3" y2="12" />
      </svg>
      Sign in with Email
    </button>
  );
};

export default LoginButton;
